module.exports = __webpack_public_path__ + "static/media/sensor.dfd9664d.jpeg";